<template>
    <tuango-base-line-chart :provider="dataProvider" title="Issued cashback"></tuango-base-line-chart>
</template>

<script>
  /* ============
   * User Metrics Component
   * ============
   *
   */
  import TuangoBaseLineChart from '@/app/components/metrics/BaseLineChart'
  import CashbackMetrics from '@/app/proxies/CashbackMetricsProxy'

  export default {
    components: {
      TuangoBaseLineChart
    },
    data () {
      return {
        dataProvider: null
      }
    },
    created () {
      this.dataProvider = new CashbackMetrics()
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/pages/Metrics/Cashback.vue